import React from 'react';
import styled from 'styled-components';
// logic
import { SETTINGS } from '../../../constants';

const PortalContainer = ({ className }) => (
  <div className={className} id={SETTINGS.PORTAL_ID}></div>
);

export default styled(PortalContainer)`
  display: flex;
  flex-grow: 1;
`;
